import React, { useState } from "react";
import {
  settingsRowCancelButtonClassName,
  settingsRowEditButtonClassName,
  settingsRowSaveButtonClassName,
} from "../common/settingsStyles";

// The website Membership Options page shows this text when the chamber has
// not saved its own introduction (same copy as the design, D:6127).
export const DEFAULT_MEMBERSHIP_OPTIONS_INTRO =
  "Becoming a Chamber Member is more than joining a network. It is an investment in your business growth, visibility, and community presence. Membership provides valuable opportunities to connect with local professionals, promote your business, participate in chamber events and advocacy initiatives, and access resources designed to help your company succeed.";

export const MEMBERSHIP_OPTIONS_INTRO_MAX_LENGTH = 2000;

type MembershipOptionsIntroFieldProps = {
  value: string | undefined;
  onChange: (value: string) => void;
};

// Claude Design "Membership Options" intro with an Edit button (D:6125-6129,
// D:6354-6358). The edit is staged into the Membership Settings section and
// saved with that section's Save.
export const MembershipOptionsIntroField = ({
  value,
  onChange,
}: MembershipOptionsIntroFieldProps) => {
  const [draft, setDraft] = useState<string | null>(null);
  const shownText = value?.trim() || DEFAULT_MEMBERSHIP_OPTIONS_INTRO;

  return (
    <div className="flex flex-col gap-[10px]">
      <p className="text-sm font-semibold text-[#0A0A0A]">Membership Options</p>
      {draft === null ? (
        <div className="flex items-start gap-3">
          <p className="flex-1 whitespace-pre-line rounded-[8px] border border-[#ECECEC] px-[14px] py-3 text-[13px] text-[#0A0A0A]">
            {shownText}
          </p>
          <button
            type="button"
            onClick={() => setDraft(shownText)}
            className={`${settingsRowEditButtonClassName} shrink-0`}
            aria-label="Edit membership options introduction"
          >
            Edit
          </button>
        </div>
      ) : (
        <div className="flex flex-col gap-[10px]">
          <textarea
            value={draft}
            onChange={(event) => setDraft(event.target.value)}
            maxLength={MEMBERSHIP_OPTIONS_INTRO_MAX_LENGTH}
            rows={4}
            aria-label="Membership options introduction"
            className="w-full resize-y rounded-[8px] border border-[#9E9E9E] px-[14px] py-3 text-[13px] text-[#0A0A0A] outline-none focus:border-cpaGold"
          />
          <div className="flex gap-2">
            <button
              type="button"
              onClick={() => {
                onChange(draft.trim());
                setDraft(null);
              }}
              className={settingsRowSaveButtonClassName}
            >
              Save
            </button>
            <button
              type="button"
              onClick={() => setDraft(null)}
              className={settingsRowCancelButtonClassName}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MembershipOptionsIntroField;
